import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Routing, { SideMenu } from '../../components/reusable/routing'

import { useLatestPathname } from '../../modules'

import Docs from './Documents'
import History from './History'

let menu = [
    {
        path: 'docs',
        title: 'Home',
        component: Docs
    },
    {
        path: 'access-history',
        title: 'Access History',
        component: History
    }
]

const Documents = () => {
    const history = useHistory()
    const { user } = useSelector(state => state.application)
    const pathname = useLatestPathname()

    useEffect(() => {
        const target = `/app/documents/${menu[0].path}`
        if (!pathname.current.startsWith(target)) history.push(target)
    }, [user])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Documents</p>
                <SideMenu namespace="documents" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="documents" menu={ menu } />
            </div>
        </div>
    )
}

export default Documents